export default {
  primary:
    "h-[40px] flex items-center justify-center bg-primary hover:bg-primary_hov text-text_inv font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  secondary:
    "h-[40px] flex items-center justify-center border border-bordered text-text hover:border-text hover:text-text font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  secondary_red:
    "h-[40px] flex items-center justify-center border border-error text-error hover:bg-error hover:text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  admin_primary:
    "h-[40px] flex items-center justify-center bg-admin_primary hover:bg-admin_primary_dk text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out ",

  admin_primary_red:
    "h-[40px] flex items-center justify-center bg-admin_error/90 hover:bg-admin_error text-white font-bold rounded-full py-2 px-4 transition-colors ease-in-out",

  admin_store: "w-[250px] flex items-center justify-center rounded-md py-5 px-5",

  admin_secondary: "h-[40px] flex items-center justify-center border border-admin_primary text-admin_primary hover:text-white hover:bg-admin_primary font-bold rounded-full py-2 px-4 transition-colors",

  admin_icon: "h-[40px] flex items-center justify-center border-0 font-bold py-2 px-4 rounded hover:text-admin_primary transition-colors",

  admin_user_settings:
    "w-full h-full flex items-center bg-transparent text-admin_text hover:text-admin_link hover:font-bold",

  admin_social_connect: "h-[40px] flex items-center justify-center text-white font-bold py-2 px-4 rounded-full",

  admin_viewer_controls:
    "h-[40px] flex items-center justify-center text-admin_text hover:text-white text-sm font-bold px-3 py-1 bg-admin_neutral_1 hover:bg-admin_neutral_2 rounded-full",

  admin_viewer_controls_small:
    "h-[28px] flex items-center justify-center text-admin_text text-sm font-bold px-3 py-1 bg-admin_neutral_1 hover:bg-admin_neutral_2 rounded",

  admin_error: "h-[40px] flex items-center justify-center border-solid border border-admin_error text-admin_error hover:text-white hover:bg-admin_error font-bold rounded-full py-2 px-4 transition-colors",

  admin_text_warning: "text-admin_warning hover:bg-admin_warning/5 underline font-medium cursor-pointer rounded-full py-2 px-4 transition-all duration-200 ease-in-out",
}
